import { FieldArray, FormikProvider, useFormik } from 'formik';
import React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ClipLoader } from 'react-spinners';
import EditModal from '../../components/infrastructure/Modals/EditModal';
import FormikInputGroup from '../../components/formik/FormikInputGroup';
import FormikTextareaGroup from '../../components/formik/FormikTextareaGroup';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import { X } from 'react-feather';
import {
    fetchDispatchLocations,
    editDispatchLocation,
    fetchDispatchLocation,
    setEditId,
    getDispatchLocation,
} from '../../app/reducers/DispatchLocation/dispatchLocationSlice';

const EditDispatchLocation = () => {
    const dispatch = useDispatch();

    const {
        elementEditId,
        editDataLoading: loading,
        elementEditData,
    } = useSelector(getDispatchLocation);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            ...elementEditData,
        },
        onSubmit: async (values) => {
            await dispatch(editDispatchLocation(values));
            await dispatch(fetchDispatchLocations());
        },
    });
    useEffect(() => {
        if (elementEditId) {
            dispatch(fetchDispatchLocation({ _id: elementEditId }));
        }
    }, [elementEditId]);
    return (
        <EditModal
            editProperty={elementEditId}
            setEditProperty={setEditId}
            getEditData={fetchDispatchLocation}
            title="Edit Dispatch Location"
        >
            {loading ? (
                <ClipLoader />
            ) : (
                <form
                    onSubmit={formik.handleSubmit}
                    className="flex flex-col gap-4 p-4"
                >
                    <FormikInputGroup
                        name="_id"
                        required
                        label="System Id"
                        readOnly
                        formik={formik}
                    />
                    <FormikInputGroup
                        formik={formik}
                        label="Name"
                        name="name"
                    />
                    {formik?.values?.name && (
                    <div className="flex flex-col gap-4">
                        <div className="flex flex-row items-center gap-4">
                            <div className="w-full">
                                <FormikInputGroup
                                    formik={formik}
                                    name="bankDetails.accountName"
                                    label="Account Name"
                                />
                            </div>
                            <div className="w-full">
                                <FormikInputGroup
                                    formik={formik}
                                    name="bankDetails.bank"
                                    label="Bank"
                                />
                            </div>
                        </div>
                        <div className="flex flex-row items-center gap-4">
                            <div className="w-full">
                                <FormikInputGroup
                                    formik={formik}
                                    name="bankDetails.accountNo"
                                    label="Account No."
                                />
                            </div>
                            <div className="w-full">
                                <FormikInputGroup
                                    formik={formik}
                                    name="bankDetails.ifscCode"
                                    label="IFSC Code"
                                />
                            </div>
                            <div className="w-full">
                                <FormikInputGroup
                                    formik={formik}
                                    name="bankDetails.branch"
                                    label="Branch"
                                />
                            </div>
                        </div>
                    </div>
                )}
                    <div className="mt-4">
                        <PrimaryButton type="submit">Edit</PrimaryButton>
                    </div>
                </form>
            )}
        </EditModal>
    );
};

export default EditDispatchLocation;
